export function friendlyDate(datetime) {
  const d = new Date(datetime);
  return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
}

export function friendlyStatus(status) {
  switch (status) {
    case 1:
      return 'Submitted';
    case 2:
      return 'Published';
    default:
      return 'Draft';
  }
}

export function friendlyRole(roles) {
  switch (Math.max(...roles)) {
    case 2:
      return 'Admin';
    case 1:
      return 'Editor';
    default:
      return 'Author';
  }
}

export default {
  methods: {
    friendlyDate,
    friendlyStatus,
    friendlyRole,
  },
};
